// Helper function to generate WebPage schema data for CMS pages
export const generateCmsPageSchema = (pageData) => {
    if (!pageData || !pageData.title) return null;
  
    // Clean HTML content for description
    const cleanContent = (content) => {
      if (!content) return '';
      // Remove HTML tags and decode entities
      return content
        .replace(/<[^>]*>/g, '') // Remove HTML tags
        .replace(/&ldquo;/g, '"') // Decode quotes
        .replace(/&rdquo;/g, '"')
        .replace(/&rsquo;/g, "'")
        .replace(/&#39;/g, "'")
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/\s+/g, ' ') // Replace multiple spaces with single space
        .trim()
        .substring(0, 300); // Limit to 300 characters
    };
  
    // Prioritize meta_description and meta_keyword fields
    const description = pageData.meta_description || cleanContent(pageData.content);
    const keywords = pageData.meta_keyword ? pageData.meta_keyword.split(',').map(k => k.trim()).join(', ') : '';
    const urlSlug = pageData.url_slug || pageData.title?.toLowerCase().replace(/\s+/g, '-');
  
    return {
      title: pageData.title,
      description: description,
      datePublished: pageData.created_at ? new Date(pageData.created_at).toISOString() : new Date().toISOString(),
      dateModified: pageData.updated_at ? new Date(pageData.updated_at).toISOString() : new Date().toISOString(),
      author: {
        name: 'JobSeekers Page',
        url: window.location.origin
      },
      publisher: {
        name: 'JobSeekers Page',
        url: window.location.origin,
        logo: {
          url: `${window.location.origin}/assets/images/jobseekers-logo.png`
        }
      },
      url: `${window.location.origin}/page/${urlSlug}`,
      keywords: keywords,
      mainEntityOfPage: {
        url: `${window.location.origin}/page/${urlSlug}`
      },
      breadcrumb: {
        name: pageData.title,
        url: `${window.location.origin}/page/${urlSlug}`
      }
    };
  };